{
  "awaleScreen": {
    "header": {
      "title": "🎯 Awalé",
      "loading": "Cargando Awalé…"
    },
    "tabs": {
      "mine": "Mis Sesiones",
      "explore": "Explorar",
      "classement": "Clasificación"
    },
    "mySessions": {
      "title": "Mis Sesiones",
      "emptyTitle": "No te has unido a ninguna sesión.",
      "emptyHint": "¡Explora las sesiones disponibles!",
      "enter": "Entrar →",
      "runLabel": "Ronda {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/turno"
    },
    "explore": {
      "title": "Sesiones Disponibles",
      "emptyTitle": "No hay sesiones disponibles.",
      "emptyHint": "Puede que ya te hayas unido a todas las sesiones.",
      "participateFree": "Participar gratis",
      "participatePaid": "Participar ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Volver a las sesiones",
      "noRunAvailable": "No hay ninguna ronda disponible para esta sesión."
    },
    "run": {
      "matchFinishedTitle": "Partida Terminada",
      "matchFinishedSub": "Esta ronda está oficialmente cerrada.\nConsulta la clasificación para ver a los ganadores.",
      "waitingForLaunch": "Esperando a que el administrador la inicie",
      "runInProgress": "Ronda en curso",
      "notInRun": "No estás en esta ronda",
      "playNow": "Jugar ahora",
      "info": {
        "run": "Ronda",
        "prep": "Prep.",
        "turn": "Turno",
        "launched": "Iniciado"
      }
    },
    "match": {
      "yourMatch": "Tu partida",
      "you": "Tú",
      "opponent": "Oponente",
      "victory": "🏆 ¡Victoria!",
      "defeat": "❌ Derrota",
      "resultPending": "Resultado pendiente"
    },
    "status": {
      "created": "⏳ En espera",
      "launched": "🔵 En curso",
      "finished": "🟢 Terminado"
    },
    "classement": {
      "title": "Clasificación",
      "emptyTitle": "No estás inscrito en ninguna sesión.",
      "backToClassement": "Volver",
      "runsCount_one": "{{count}} ronda",
      "runsCount_other": "{{count}} rondas",
      "matchesCount": "{{finished}}/{{total}} partidas",
      "noRunAvailable": "No hay ninguna ronda disponible.",
      "noMatchInRun": "No hay partidas en esta ronda",
      "matchLabel": "Partida {{number}}",
      "matchDone": "✅ Terminada",
      "matchLive": "🔵 En curso",
      "winnerLabel": "Ganador · {{name}}"
    },
    "errors": {
      "joinSession": "Error al unirse a la sesión",
      "loadRun": "Error al cargar la ronda",
      "sessionExpired": "Sesión caducada — vuelve a iniciar sesión"
    }
  },
  "damesScreen": {
    "header": {
      "title": "♟️ Damas",
      "loading": "Cargando Damas…"
    },
    "tabs": {
      "mine": "Mis Sesiones",
      "explore": "Explorar",
      "classement": "Clasificación"
    },
    "mySessions": {
      "title": "Mis Sesiones",
      "emptyTitle": "No te has unido a ninguna sesión.",
      "emptyHint": "¡Explora las sesiones disponibles!",
      "enter": "Entrar →",
      "runLabel": "Ronda {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/turno"
    },
    "explore": {
      "title": "Sesiones Disponibles",
      "emptyTitle": "No hay sesiones disponibles.",
      "emptyHint": "Puede que ya te hayas unido a todas las sesiones.",
      "participateFree": "Participar gratis",
      "participatePaid": "Participar ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Volver a las sesiones",
      "noRunAvailable": "No hay ninguna ronda disponible para esta sesión."
    },
    "run": {
      "matchFinishedTitle": "Partida Terminada",
      "matchFinishedSub": "Esta ronda está oficialmente cerrada.\nConsulta la clasificación para ver a los ganadores.",
      "waitingForLaunch": "Esperando a que el administrador la inicie",
      "runInProgress": "Ronda en curso",
      "notInRun": "No estás en esta ronda",
      "playNow": "Jugar ahora",
      "info": {
        "run": "Ronda",
        "prep": "Prep.",
        "turn": "Turno",
        "launched": "Iniciado"
      }
    },
    "match": {
      "yourMatch": "Tu partida",
      "you": "Tú",
      "opponent": "Oponente",
      "victory": "🏆 ¡Victoria!",
      "defeat": "❌ Derrota",
      "resultPending": "Resultado pendiente"
    },
    "status": {
      "created": "⏳ En espera",
      "launched": "🔵 En curso",
      "finished": "🟢 Terminado"
    },
    "classement": {
      "title": "Clasificación",
      "emptyTitle": "No estás inscrito en ninguna sesión.",
      "backToClassement": "Volver",
      "runsCount_one": "{{count}} ronda",
      "runsCount_other": "{{count}} rondas",
      "matchesCount": "{{finished}}/{{total}} partidas",
      "noRunAvailable": "No hay ninguna ronda disponible.",
      "noMatchInRun": "No hay partidas en esta ronda",
      "matchLabel": "Partida {{number}}",
      "matchDone": "✅ Terminada",
      "matchLive": "🔵 En curso",
      "winnerLabel": "Ganador · {{name}}"
    },
    "errors": {
      "joinSession": "Error al unirse a la sesión",
      "loadRun": "Error al cargar la ronda",
      "sessionExpired": "Sesión caducada — vuelve a iniciar sesión"
    }
  },
  "tabAwale": {
    "connecting": "Conectando al servidor…",
    "loadingMatch": "Cargando la partida…",
    "back": "Volver",
    "connectionError": "No se pudo conectar al servidor",
    "prep": {
      "title": "Preparación",
      "subtitle": "La partida comienza en",
      "unit": "segundos",
      "hint": "Tu oponente puede unirse en cualquier momento"
    },
    "tiebreaker": {
      "banner": "🔥 Empate — ¡El primero en llegar a 12 gana!",
      "small": "🔥 Ronda de desempate — Primero a 12",
      "badge": "🔥 Ronda de desempate"
    },
    "gameOver": {
      "victory": "¡Victoria!",
      "defeat": "Derrota",
      "reasonTimeout": "Tiempo agotado",
      "reasonScore": "Puntuación alcanzada",
      "reasonEmpty": "Tablero vacío",
      "you": "Tú",
      "opponent": "Oponente",
      "done": "Terminar"
    },
    "yourTurn": "🟢 Tu turno",
    "opponentTurn": "⏳ Turno del oponente",
    "moveNumber": "Jugada #{{number}}",
    "reconnecting": "⚠ Reconectando…"
  },
  "tabDames": {
    "connecting": "Conectando al servidor…",
    "loadingMatch": "Cargando la partida…",
    "back": "Volver",
    "connectionError": "No se pudo conectar al servidor",
    "prep": {
      "title": "Preparación",
      "subtitle": "La partida comienza en",
      "unit": "segundos",
      "hint": "Las rojas juegan primero"
    },
    "suddenDeath": {
      "banner": "⚡ Muerte súbita — ¡El primero en {{target}} capturas gana!",
      "small": "⚡ Muerte súbita — {{current}}/{{target}} capturas",
      "badge": "⚡ Muerte súbita"
    },
    "gameOver": {
      "victory": "¡Victoria!",
      "defeat": "Derrota",
      "reasonTimeout": "Tiempo agotado",
      "reasonNoPieces": "Sin fichas restantes",
      "reasonNoMoves": "Ningún movimiento posible",
      "reasonSuddenDeath": "{{target}} capturas alcanzadas",
      "youPlay": "Juegas con las {{color}}",
      "colorRed": "Rojas",
      "colorBlack": "Negras",
      "captures": "Capturas",
      "done": "Terminar",
      "opponent": "Oponente"
    },
    "yourTurn": "🟢 Tu turno",
    "opponentTurn": "⏳ Turno del oponente",
    "chainCapture": "🔗 ¡Captura en cadena!",
    "youAre": "Juegas con las {{color}} ↓",
    "moveCount": "Jugada #{{number}}",
    "reconnecting": "⚠ Reconectando…",
    "movesAvailable_one": "{{count}} movimiento posible",
    "movesAvailable_other": "{{count}} movimientos posibles",
    "noMoveAvailable": "Ningún movimiento posible",
    "capturesShort": "cap."
  },
  "performanceScreen": {
    "header": {
      "title": "🎭 Performance",
      "subtitle": "Concurso de performance"
    },
    "tabs": {
      "sessions": "Sesiones",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Clasificación"
    },
    "empty": {
      "noSessionJoined": "Ninguna sesión unida",
      "exploreHint": "Explora los concursos disponibles",
      "noActiveRun": "No hay ninguna ronda activa para esta sesión",
      "noContestAvailable": "No hay ningún concurso disponible",
      "comeBackLater": "Vuelve más tarde",
      "noSubmissionOpenRun": "No hay ninguna ronda abierta para envíos",
      "waitAdminHint": "Espera a que el administrador abra los envíos",
      "noResultAvailable": "No hay ningún resultado disponible",
      "resultsAppearHint": "La clasificación aparece cuando las votaciones están abiertas"
    },
    "noActiveRunBadge": "Ninguna ronda activa",
    "back": "Volver",
    "notEnrolled": "Aún no estás inscrito en esta ronda",
    "submitVideosButton_one": "Enviar {{count}} video",
    "submitVideosButton_other": "Enviar {{count}} videos",
    "completeSubmissions": "Completar mis envíos ({{current}}/{{max}})",
    "mySubmissions": "Mis envíos ({{current}}/{{max}})",
    "participateFree": "Participar — Gratis",
    "participatePaid": "Participar — {{price}} CFA",
    "videosToSubmit_one": "{{count}} video por enviar",
    "videosToSubmit_other": "{{count}} videos por enviar",
    "videosRequired_one": "{{count}} video requerido",
    "videosRequired_other": "{{count}} videos requeridos",
    "chooseRun": "Elegir una ronda",
    "chooseAnotherRun": "Elegir otra ronda",
    "videosProgress_one": "{{count}} video",
    "videosProgress_other": "{{count}} videos",
    "readyToSend": "✓ Listo para enviar",
    "missingVideos_one": "{{count}} pendiente",
    "missingVideos_other": "{{count}} pendientes",
    "ruleExact": "Esta ronda requiere exactamente",
    "ruleAllSlots": "Todos los espacios deben completarse antes de enviar.",
    "sendVideos_one": "Enviar {{count}} video",
    "sendVideos_other": "Enviar {{count}} videos",
    "fillAllSlots": "Completa todos los espacios ({{ready}}/{{total}})",
    "successTitle": "✅ Envío completo",
    "successMessage_one": "¡Tu video se envió con éxito!",
    "successMessage_other": "¡Tus {{count}} videos se enviaron con éxito!",
    "status": {
      "draft": "📝 Borrador",
      "submissionsOpen": "🎥 Envíos abiertos",
      "votingOpen": "🗳️ Votación abierta",
      "finished": "🏆 Terminado"
    },
    "slot": {
      "videoLabel": "Video {{number}}",
      "alreadySubmitted": "Ya enviado",
      "required": "Requerido",
      "tapToChoose": "Toca para elegir",
      "tapToChange": "Toca para cambiar",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Descripción (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Video {{current}}/{{total}} — Preparando…",
      "sending": "Video {{current}}/{{total}} — Enviando…",
      "saving": "Video {{current}}/{{total}} — Guardando…",
      "uploadFailed": "Error al subir el video {{number}} ({{status}})"
    },
    "permission": {
      "title": "Permiso requerido",
      "message": "Permite el acceso a tu galería."
    }
  },
  "musicScreen": {
    "header": {
      "title": "🎵 Music",
      "subtitle": "Concurso de música"
    },
    "tabs": {
      "sessions": "Sesiones",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Clasificación"
    },
    "empty": {
      "noSessionJoined": "Ninguna sesión unida",
      "exploreHint": "Explora los concursos disponibles",
      "noActiveRun": "No hay ninguna ronda activa para esta sesión",
      "noContestAvailable": "No hay ningún concurso disponible",
      "comeBackLater": "Vuelve más tarde",
      "noSubmissionOpenRun": "No hay ninguna ronda abierta para envíos",
      "waitAdminHint": "Espera a que el administrador abra los envíos",
      "noResultAvailable": "No hay ningún resultado disponible",
      "resultsAppearHint": "La clasificación aparece cuando las votaciones están abiertas"
    },
    "noActiveRunBadge": "Ninguna ronda activa",
    "back": "Volver",
    "notEnrolled": "Aún no estás inscrito en esta ronda",
    "submitVideosButton_one": "Enviar {{count}} video",
    "submitVideosButton_other": "Enviar {{count}} videos",
    "completeSubmissions": "Completar mis envíos ({{current}}/{{max}})",
    "mySubmissions": "Mis envíos ({{current}}/{{max}})",
    "participateFree": "Participar — Gratis",
    "participatePaid": "Participar — {{price}} CFA",
    "videosToSubmit_one": "{{count}} video por enviar",
    "videosToSubmit_other": "{{count}} videos por enviar",
    "videosRequired_one": "{{count}} video requerido",
    "videosRequired_other": "{{count}} videos requeridos",
    "chooseRun": "Elegir una ronda",
    "chooseAnotherRun": "Elegir otra ronda",
    "videosProgress_one": "{{count}} video",
    "videosProgress_other": "{{count}} videos",
    "readyToSend": "✓ Listo para enviar",
    "missingVideos_one": "{{count}} pendiente",
    "missingVideos_other": "{{count}} pendientes",
    "ruleExact": "Esta ronda requiere exactamente",
    "ruleAllSlots": "Todos los espacios deben completarse antes de enviar.",
    "sendVideos_one": "Enviar {{count}} video",
    "sendVideos_other": "Enviar {{count}} videos",
    "fillAllSlots": "Completa todos los espacios ({{ready}}/{{total}})",
    "successTitle": "✅ Envío completo",
    "successMessage_one": "¡Tu video se envió con éxito!",
    "successMessage_other": "¡Tus {{count}} videos se enviaron con éxito!",
    "status": {
      "draft": "📝 Borrador",
      "submissionsOpen": "🎥 Envíos abiertos",
      "votingOpen": "🗳️ Votación abierta",
      "finished": "🏆 Terminado"
    },
    "slot": {
      "videoLabel": "Video {{number}}",
      "alreadySubmitted": "Ya enviado",
      "required": "Requerido",
      "tapToChoose": "Toca para elegir",
      "tapToChange": "Toca para cambiar",
      "formats": "MP3 · WAV · M4A",
      "descriptionPlaceholder": "Descripción (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Audio {{current}}/{{total}} — Preparando…",
      "sending": "Audio {{current}}/{{total}} — Enviando…",
      "saving": "Audio {{current}}/{{total}} — Guardando…",
      "uploadFailed": "Error al subir el audio {{number}} ({{status}})"
    }
  },
  "artisanatScreen": {
    "header": {
      "title": "🪡 Artesanía",
      "subtitle": "Concurso de artesanía"
    },
    "tabs": {
      "sessions": "Sesiones",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Clasificación"
    },
    "empty": {
      "noSessionJoined": "Ninguna sesión unida",
      "exploreHint": "Explora los concursos disponibles",
      "noActiveRun": "No hay ninguna ronda activa para esta sesión",
      "noContestAvailable": "No hay ningún concurso disponible",
      "comeBackLater": "Vuelve más tarde",
      "noSubmissionOpenRun": "No hay ninguna ronda abierta para envíos",
      "waitAdminHint": "Espera a que el administrador abra los envíos",
      "noResultAvailable": "No hay ningún resultado disponible",
      "resultsAppearHint": "La clasificación aparece cuando las votaciones están abiertas"
    },
    "noActiveRunBadge": "Ninguna ronda activa",
    "back": "Volver",
    "notEnrolled": "Aún no estás inscrito en esta ronda",
    "submitVideosButton_one": "Enviar {{count}} video",
    "submitVideosButton_other": "Enviar {{count}} videos",
    "completeSubmissions": "Completar mis envíos ({{current}}/{{max}})",
    "mySubmissions": "Mis envíos ({{current}}/{{max}})",
    "participateFree": "Participar — Gratis",
    "participatePaid": "Participar — {{price}} CFA",
    "videosToSubmit_one": "{{count}} video por enviar",
    "videosToSubmit_other": "{{count}} videos por enviar",
    "videosRequired_one": "{{count}} video requerido",
    "videosRequired_other": "{{count}} videos requeridos",
    "chooseRun": "Elegir una ronda",
    "chooseAnotherRun": "Elegir otra ronda",
    "videosProgress_one": "{{count}} video",
    "videosProgress_other": "{{count}} videos",
    "readyToSend": "✓ Listo para enviar",
    "missingVideos_one": "{{count}} pendiente",
    "missingVideos_other": "{{count}} pendientes",
    "ruleExact": "Esta ronda requiere exactamente",
    "ruleAllSlots": "Todos los espacios deben completarse antes de enviar.",
    "sendVideos_one": "Enviar {{count}} video",
    "sendVideos_other": "Enviar {{count}} videos",
    "fillAllSlots": "Completa todos los espacios ({{ready}}/{{total}})",
    "successTitle": "✅ Envío completo",
    "successMessage_one": "¡Tu video se envió con éxito!",
    "successMessage_other": "¡Tus {{count}} videos se enviaron con éxito!",
    "status": {
      "draft": "📝 Borrador",
      "submissionsOpen": "🎥 Envíos abiertos",
      "votingOpen": "🗳️ Votación abierta",
      "finished": "🏆 Terminado"
    },
    "slot": {
      "videoLabel": "Video {{number}}",
      "alreadySubmitted": "Ya enviado",
      "required": "Requerido",
      "tapToChoose": "Toca para elegir",
      "tapToChange": "Toca para cambiar",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Descripción (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Video {{current}}/{{total}} — Preparando…",
      "sending": "Video {{current}}/{{total}} — Enviando…",
      "saving": "Video {{current}}/{{total}} — Guardando…",
      "uploadFailed": "Error al subir el video {{number}} ({{status}})"
    },
    "permission": {
      "title": "Permiso requerido",
      "message": "Permite el acceso a tu galería."
    }
  },
  "artsScreen": {
    "header": {
      "title": "🎨 Arte",
      "subtitle": "Concursos creativos"
    },
    "tabs": {
      "sessions": "Sesiones",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Clasificación"
    },
    "empty": {
      "noSessionJoined": "Ninguna sesión unida",
      "exploreHint": "Explora los concursos disponibles",
      "noActiveRun": "No hay ninguna ronda activa para esta sesión",
      "noContestAvailable": "No hay ningún concurso disponible",
      "comeBackLater": "Vuelve más tarde",
      "noSubmissionOpenRun": "No hay ninguna ronda abierta para envíos",
      "waitAdminHint": "Espera a que el administrador abra los envíos",
      "noResultAvailable": "No hay ningún resultado disponible",
      "resultsAppearHint": "La clasificación aparece cuando las votaciones están abiertas"
    },
    "noActiveRunBadge": "Ninguna ronda activa",
    "back": "Volver",
    "notEnrolled": "Aún no estás inscrito en esta ronda",
    "submitWorksButton_one": "Enviar {{count}} obra",
    "submitWorksButton_other": "Enviar {{count}} obras",
    "completeSubmissions": "Completar mis envíos ({{current}}/{{max}})",
    "mySubmissions": "Mis envíos ({{current}}/{{max}})",
    "participateFree": "Participar — Gratis",
    "participatePaid": "Participar — {{price}} CFA",
    "worksToSubmit_one": "{{count}} obra por enviar",
    "worksToSubmit_other": "{{count}} obras por enviar",
    "worksRequired_one": "{{count}} obra requerida",
    "worksRequired_other": "{{count}} obras requeridas",
    "chooseRun": "Elegir una ronda",
    "chooseAnotherRun": "Elegir otra ronda",
    "worksProgress_one": "{{count}} obra",
    "worksProgress_other": "{{count}} obras",
    "readyToSend": "✓ Listo para enviar",
    "missingWorks_one": "{{count}} pendiente",
    "missingWorks_other": "{{count}} pendientes",
    "ruleExact": "Esta ronda requiere exactamente",
    "ruleAllSlots": "Todos los espacios deben completarse antes de enviar.",
    "sendWorks_one": "Enviar {{count}} obra",
    "sendWorks_other": "Enviar {{count}} obras",
    "fillAllSlots": "Completa todos los espacios ({{ready}}/{{total}})",
    "successTitle": "✅ Envío completo",
    "successMessage_one": "¡Tu obra se envió con éxito!",
    "successMessage_other": "¡Tus {{count}} obras se enviaron con éxito!",
    "status": {
      "draft": "📝 Borrador",
      "submissionsOpen": "🖼️ Envíos abiertos",
      "votingOpen": "🗳️ Votación abierta",
      "finished": "🏆 Terminado"
    },
    "quota": "{{current}}/{{max}} envío",
    "quota_other": "{{current}}/{{max}} envíos",
    "slot": {
      "workLabel": "Obra {{number}}",
      "alreadySubmitted": "Ya enviada",
      "required": "Requerido",
      "tapToChoose": "Toca para elegir",
      "tapToChange": "Toca para cambiar",
      "formats": "JPG · PNG · WEBP",
      "descriptionPlaceholder": "Descripción (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Imagen {{current}}/{{total}} — Preparando…",
      "sending": "Imagen {{current}}/{{total}} — Enviando…",
      "saving": "Imagen {{current}}/{{total}} — Guardando…",
      "uploadFailed": "Error al subir la imagen {{number}} ({{status}})"
    },
    "permission": {
      "title": "Permiso requerido",
      "message": "Permite el acceso a tu galería."
    }
  },
  "vraiFauxScreen": {
    "title": "Verdadero o Falso",
    "loading": "Cargando…",
    "tabs": {
      "sessions": "Sesiones",
      "explore": "Explorar",
      "answers": "Respuestas",
      "results": "Resultados"
    },
    "headerSub": {
      "groups": "GRUPOS",
      "questions": "PREGUNTAS",
      "mySessions": "MIS SESIONES",
      "explore": "EXPLORAR",
      "myAnswers": "MIS RESPUESTAS",
      "myResults": "MIS RESULTADOS"
    },
    "mine": {
      "emptyTitle": "Ninguna sesión unida",
      "emptySub": "¡Explora las sesiones disponibles y participa!",
      "exploreAction": "Explorar",
      "groupsLabel": "GRUPOS",
      "openGroup": "Grupo abierto a todos",
      "minScore": "Puntuación mín.: {{score}} pts",
      "locked": "🔒 Requerido: {{required}} pts · Tú: {{current}} pts",
      "answerButton": "Responder",
      "insufficientScore": "Puntuación insuficiente — tienes {{current}} pts, se requieren {{required}} pts",
      "allAnswered": "¡Todas las preguntas respondidas!",
      "backToGroups": "Volver a los grupos",
      "questionCounter": "Pregunta {{current}} / {{total}}",
      "previous": "Anterior",
      "next": "Siguiente"
    },
    "explore": {
      "allJoinedTitle": "¡Todo unido!",
      "allJoinedSub": "Participas en todas las sesiones disponibles.",
      "free": "Gratis",
      "paid": "💰 {{price}} CFA",
      "participate": "Participar"
    },
    "answers": {
      "participatedSessions": "SESIONES EN LAS QUE PARTICIPAS",
      "emptyTitle": "Ninguna respuesta",
      "emptySub": "Participa en una sesión para ver tus respuestas.",
      "groupsLabel": "GRUPOS — {{session}}",
      "myAnswersLabel": "MIS RESPUESTAS",
      "infoBanner": "Las puntuaciones y las respuestas correctas serán reveladas por el administrador en la pestaña Resultados",
      "emptyRunTitle": "Ninguna respuesta",
      "emptyRunSub": "Aún no has respondido a ninguna pregunta en este grupo.",
      "myAnswerWas": "Respondí: {{answer}}"
    },
    "results": {
      "participatedSessions": "SESIONES EN LAS QUE PARTICIPAS",
      "emptyTitle": "Ningún resultado",
      "emptySub": "Participa en una sesión para ver tus resultados.",
      "groupsLabel": "GRUPOS — {{session}}",
      "pendingTitle": "Resultados aún no revelados",
      "pendingDefaultMsg": "El administrador revelará los resultados tras el cierre de la ronda.",
      "scoreRevealed": "Puntuación revelada:",
      "notPlayed": "No jugado",
      "pointsAwarded": "+{{points}} pts"
    },
    "true": "VERDADERO",
    "false": "FALSO",
    "points": "{{count}} pts",
    "errors": {
      "network": "Error de red",
      "notConnected": "No conectado",
      "sessionExpired": "Sesión caducada — vuelve a iniciar sesión",
      "submitError": "Error al enviar"
    }
  }
}
